export default __webpack_public_path__ + "77ab9d3334a4d6660bc2cba7a4cfda82.svg";